<template>
  <v-app>
    <v-main class="primary">
      <Hero />
      <SuccessSnackbar />
      <v-container class="py-0">
        <v-row>
          <v-spacer></v-spacer> <!-- Left Margin -->
          <v-col cols="12" sm="10" md="12" xl="10" class="py-0">
            <Support />
          </v-col>
          <v-spacer></v-spacer> <!-- Right Margin -->
        </v-row>
      </v-container>

      <Reinforcement />

      <v-container class="pt-0 benefitsContainer">
        <v-row>
          <v-spacer></v-spacer> <!-- Left Margin -->
          <v-col cols="12" sm="10" md="12" xl="10" class="py-0">
            <Benefits />
          </v-col>
          <v-spacer></v-spacer> <!-- Right Margin -->
        </v-row>
      </v-container>

      <v-container class="py-0 testimonialsContainer" dense>
        <v-row class="pt-0">
          <v-spacer class="pt-0"></v-spacer> <!-- Left Margin -->
          <v-col cols="12" lg="10" xl="8" class="py-0">
            <Testimonials />
          </v-col>
          <v-spacer class="pt-0"></v-spacer> <!-- Right Margin -->
        </v-row>
      </v-container>

      <!-- <v-container class="pt-0 benefitsContainer">
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" lg="10" xl="8" class="py-0">
            <ContactForm />
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </v-main> -->

      <ClosingArgument />

    <Footer />
    <!-- <Navbar /> -->
    </v-main>
  </v-app>
</template>

<script>
// Components
// import Support from '@/components/HeroSupport.vue';
// import Benefits from '@/components/TheBenefits.vue';
import Hero from '@/components/TheHero.vue';
// import Testimonials from '@/components/TheTestimonials.vue';
// import ClosingArgument from '@/components/TheClosingArgument.vue';
// import Footer from '@/components/TheFooter.vue';
// import Navbar from '@/components/TheNavbar.vue';
// import SuccessSnackbar from '@/components/successSnackbar.vue';
// import Reinforcement from '@/components/TheReinforcement.vue';
const Reinforcement = () => import('@/components/TheReinforcement.vue');
const Benefits = () => import('@/components/TheBenefits.vue');
const Support = () => import('@/components/HeroSupport.vue');
const Testimonials = () => import('@/components/TheTestimonials.vue');
const ClosingArgument = () => import('@/components/TheClosingArgument.vue');
const Footer = () => import('@/components/TheFooter.vue');
const SuccessSnackbar = () => import('@/components/successSnackbar.vue');
// const ContactForm = () => import('@/components/TheContactForm.vue');

// Vuex
// import { mapState, mapActions } from 'vuex';

export default {
  name: 'App',

  components: {
    // Navbar,
    Hero,
    Support,
    Reinforcement,
    Benefits,
    Testimonials,
    ClosingArgument,
    Footer,
    SuccessSnackbar,
    // ContactForm,
  },
  // methods: {
  //   onResize() {
  //     // console.log(`Current breakpoint: ${this.$vuetify.breakpoint.name}`);
  //   },
  // },
  // mounted() {
  //   // Only for dev purposes- disable for production.
  //   this.onResize();
  // },

  // data: () => ({
  //   //
  // }),
  // computed: mapState([
  //   'displaySnackbar',
  // ]),
  // methods: {
  //   ...mapActions(['toggleSnackbar']),
  //   scheduleSnackbar() {
  //     this.toggleSnackbar();
  //     setTimeout(this.toggleSnackbar, 3000);
  //   },
  // },


};
</script>

<style>
  .title-fix {
      /* See: https://codepen.io/MatthewAry/pen/WNeWmPp
          from https://github.com/vuetifyjs/vuetify/issues/9130
      */
      overflow-wrap: anywhere;
      word-wrap: break-word;
      word-break: normal;
      hyphens: auto;
  }

  /* @font-face {
    font-family: "renner";
    src: url("./assets/fonts/Renner-400-Book.ttf") format("truetype");
  }

  .ren {
    font-family: 'renner'
  } */

</style>
